import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

// react-router-dom v6+ dropped the v5 pattern of injecting match/history/
// location props into a <Route component={...}>'s element - route state
// is only reachable via hooks now. This shim lets the existing class
// components (Layout, SolvedJoke) go on reading this.props.match.params.id
// and this.props.history.replace(path) unchanged.
export function withRouter(WrappedComponent) {
  return function ComponentWithRouterProp(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return (
      <WrappedComponent
        {...props}
        match={{ params }}
        location={location}
        history={{
          push: (path) => navigate(path),
          replace: (path) => navigate(path, { replace: true }),
        }}
      />
    );
  };
}
